import * as React from 'react'
import { GridCell } from '@progress/kendo-react-grid'
import { downloadFile } from '@/utils/downloader'
import Icon from '@/components/Icon'
import LoadingIndicator from '@/components/LoadingIndicator'
import context from '@/context'
import fetch from '@/utils/fetch'

const fileDownloadCell = ({ downloadAction, localize, isChangeRequest = true }) => {
  return class FileDownloadCell extends GridCell {
    constructor (props) {
      super(props)

      this.state = {
        status: null,
        fetching: false,
        error: null
      }
    }
    componentDidMount () {
      if (this.state.status === null && !this.props.dataItem.verified) { this.findFileStatus() }
    }
    downloadApi = () => {
      if (isChangeRequest) {
        return this.props.dataItem.__EXISTS ? downloadAction : context.api.changeRequestService.download
      }
      return downloadAction
    }
    findFileStatus = () => {
      this.setState({ fetching: true }, () => {
        const guid = this.props.dataItem[this.props.field]
        fetch(context.config.apiGatewayUrl + 'api/file/status/' + guid)
          .then(r => this.setState({ fetching: false, status: r }))
          .catch(err => this.setState({ fetching: false, error: err }))
      })
    }
    onDownloadClick = () => {
      const guid = this.props.dataItem[this.props.field]
      downloadFile(guid, this.downloadApi())
    }
    renderDownloadButton = () => {
      const isDownloadActionDefined = typeof this.downloadApi() === 'function'
      if (isDownloadActionDefined === true) { return <button type='button' onClick={this.onDownloadClick}> <Icon name='download' /></button> }
      return null
    }
    render () {
      if (this.props.dataItem.verified || this.state.status === 2) {
        return <td>{this.renderDownloadButton()}</td>
      } else {
        if (this.state.fetching) { return <td><LoadingIndicator inline /></td> }

        return (
          <td>
            <button onClick={this.findFileStatus}> <Icon name='revision' /></button>
            <span className='ml-1' title={localize('Common.FileNotVerified')}>
              <Icon name='check' />
            </span>
          </td>
        )
      }
    }
  }
}

export {
  fileDownloadCell
}



// WEBPACK FOOTER //
// ./src/components/BsrsGrid/fileDownloadCell.js